import { useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { createRadioGroupField } from 'libs/client-portal-shared/src/app/components/formComponents/common/componentBuilder';
import { Card } from '@roc/ui';

const useStyles = makeStyles(theme => ({
  card: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  buttonStyle: {
    margin: theme.spacing(1),
  },
}));



export const TamariskPreferences = observer(({ companyProfileStore }) => {
  const { lenderDetailsStore } = companyProfileStore;
  const { lenderDetailsFormStore,salesforceLenderStore, globalStore } = lenderDetailsStore;
  const { portal, internalUser, isDecisionCommittee } = salesforceLenderStore;
  const [editTamariskPreferences, setEditTamariskPreferences] = useState(false);
  const classes = useStyles();

  const isLead = portal === 'Internal'
        ? (internalUser.roles.includes('decisionCommittee') || internalUser.roles.includes('tech') || isDecisionCommittee)
        : globalStore.userFeatures.backOfficeLead;

  const cardProps = isLead ? { onEdit: () => setEditTamariskPreferences(true) } : {};

  const handleSave = () => {
    lenderDetailsStore.saveTamariskInformation();
    setEditTamariskPreferences(false);
  };

  const handleCancel = () => {
    setEditTamariskPreferences(false);
  };


  return (
    <>
      <Card title='AMC PREFERENCES' cardContentProps={{ style: { padding: 0 } }} className={classes.card} {...cardProps}>
        <Box p={4}>
          <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between">
            <Box flex={1}>
              {createRadioGroupField({
                store: lenderDetailsFormStore,
                fieldName: 'tamariskSendInvoiceEmail',
                label: 'Automatically send borrowers an appraisal payment email upon loan submission',
                disabled: !editTamariskPreferences
              })}
            </Box>
          </Box>
          {editTamariskPreferences && (
            <Grid item xs={12} container justifyContent="flex-end">
              <Button
                style={{ marginRight: 16 }}
                variant="outlined"
                onClick={handleCancel}
                color="default"
                className={classes.buttonStyle}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                color="primary"
                variant="contained"
                className={classes.buttonStyle}
              >
                Save
              </Button>
            </Grid>
          )}
        </Box>
      </Card>
    </>
  );
});

export default TamariskPreferences;
